<template>
  <div class="weiVCon videoD">
    <div class="trainListBox">
      <div
        v-show="isHasdata"
        class=""
      >
        <div v-if="!isLogin">
          <router-link to="/login">
            <img
              src="../assets/imgs/toLoginIcon.png"
              alt=""
              class="toLoginIcon"
            >

            <img
              src="../assets/imgs/nonLoginTxt.png"
              alt=""
              class="nonLoginTxt"
            >
          </router-link>
        </div>
        <div v-if="isLogin">
          <div
            class="trainItems"
            v-for="item in classlist"
            :key="item.index"
          >
            <div class="clearfix">
              <div class="fl">
                <div class="trainTit">
                  <img
                    src="../assets/imgs/huangg.png"
                    alt=""
                  >
                  {{item.title}}
                </div>
                <p>{{item.remark}}</p>
                <p v-if="item.isPay === 1 || item.money == 0">学习进度：{{item.progress}}%（{{item.validTime}}/{{item.totalTime}}分钟）</p>
                <div
                  class="hasBuy isBuy"
                  v-if="item.isPay === 1  || item.money == 0"
                >
                  <img
                    src="../assets/imgs/sure.png"
                    alt=""
                  >
                  <!-- 已购买<span>（有效期至{{item.expDate!=="" && item.expDate!==null?item.expDate:""}}）</span> -->
                  已购买<span>（{{item.year+'-'+item.month}}）</span>
                </div>
                <div
                  class="nonBuy isBuy"
                  v-else
                >
                  <img
                    src="../assets/imgs/money.png"
                    alt=""
                  >
                  {{item.money}}
                </div>
              </div>
              <div class="fr">
                <!-- 1出租车 2道路运输 3专项学习 4安全学习 5两类人员-->
                <img v-if="1===1" src="../assets/imgs/czcType.png" alt="" class="classType">
                <img v-else-if="2===2" src="../assets/imgs/dlysType.png" alt="" class="classType">
                <img v-else-if="3===3" src="../assets/imgs/zxxxType.png" alt="" class="classType">
                <img v-else-if="4===4" src="../assets/imgs/aqxxType.png" alt="" class="classType">
                <img v-else-if="5===5" src="../assets/imgs/llryType.png" alt="" class="classType">
                <mt-button
                  v-if="item.isPay===1 || item.money==0"
                  type="default"
                  class="trainBtn btnStudy"
                  @click="toCourseList(item.year)"
                >去学习</mt-button>
                <router-link
                  v-else
                  :to="{path:'/pay',query:{planId:item.id}}"
                  class="trainBtn btnStudy"
                >去购买</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="!isHasdata"
        class="noData"
      >
        <img
          src="../assets/imgs/noDataIcon.png"
          alt=""
        >
        <p class="noDataTit">未查询到相关数据</p>
        <p>暂无数据，请刷新重试</p>
      </div>
    </div>
    <van-popup v-model="showBox" style="width:85%;">
        <van-radio-group @change="gtSelect" v-model="isGt">
          <van-radio name="0">企业</van-radio>
          <van-radio name="1">个体</van-radio>
        </van-radio-group>
        <van-field
          readonly
          clickable
          label="省份"
          :value="ptext"
          placeholder="选择省份"
          @click="selectData(0)"
        />
        <van-field
          readonly
          clickable
          label="城市"
          :value="ctext"
          placeholder="选择城市"
          @click="selectData(1)"
          
        />
        <van-field
          v-if='isGt==="0"'
          readonly
          clickable
          label="企业"
          :value="companyText"
          placeholder="选择企业"
          @click="selectData(2)"
          
        />
        <van-cell-group style="float: right;">
          <van-button @click="qx" size="small">取消</van-button>
          <van-button @click="sure" size="small" type="info">确定</van-button>
        </van-cell-group>
    </van-popup>
    <van-popup v-model="needwsBox" position="bottom">
      <van-picker
      show-toolbar
      title="请选择"
      :columns="dataList"
      @cancel="onCancel"
      @confirm="onConfirm"
    />
    </van-popup>
  </div>
</template>
<style scoped>
html {
  background: #fff;
}
.van-radio-group {
      display: flex;
    justify-content: space-around;
    padding: 20px;
}
.van-hairline--top-bottom{
  margin: 20px 20px 20px 0;
}

</style>
<script>
import { Toast, Indicator } from 'mint-ui'
import { getTrainlist,getTrainlistAqxx,needws,getProvince,getCity,getCompany,perfect } from '../../src/api/Api'
import { mapGetters } from 'vuex'
import { Popup } from 'vant'
import { Picker,RadioGroup, Radio } from 'vant'


export default {
  name: 'videoD',
  data () {
    return {
      classlist: [],
      isLogin: false, // 是否登录
      isHasdata: true,
      dataList:[],
      showBox:false,
      needwsBox:false,
      yearTerm:'',
      hyTerm:0,
      pcode:'',
      ptext:'',
      ccode:'',
      ctext:'',
      companyId:'',
      companyText:'',
      curSelType:0,
      isGt:'0'
    }
  },
  computed: {
    ...mapGetters(['stuId', 'ProfessionId'])
  },
  created () {
    var userId = sessionStorage.getItem('userId')
    if (userId === '' || userId === null || userId === undefined) {
      this.isLogin = false
    } else {
      this.isLogin = true
      this.getTrainlists();
      this.$store.dispatch('SetPlatform', 3);
    }
  },
  destroyed () {
    Indicator.close()
  },
  methods: {
    gtSelect:function(){
      console.log(this.isGt);
    },
    selectData:function(t){
      var that = this;
      that.curSelType = t;
        that.dataList = [];
      if(that.curSelType===0){
        that.needwsBox  = true;
        that.getProvince();
      }
      if(that.curSelType===1){
        if(that.pcode===''){
         Toast("请选择省份")
         return;
        }
        that.needwsBox  = true;
        that.getCity({code:that.pcode});
      }
      
      if(that.curSelType===2){
        if(that.ccode===''){
         Toast("请选择城市")
         return;
        }
        that.needwsBox  = true;
        that.getCompany({code:that.ccode});
      }
    },
    qx(){
      this.showBox = false;
    },
    sure:function(){
      var that = this;
      if(that.pcode==='' || that.pcode===undefined){
         Toast("请选择省份")
         return;
      }
      if(that.ccode==='' || that.ccode===undefined){
         Toast("请选择城市")
         return;
        }
      if(that.isGt==='0')  {
        if(that.companyId==='' || that.companyId===undefined){
          Toast("请选择企业")
          return;
        }
      }

      if(that.isGt==='1'){
        that.companyId = ''
      }
      var params = {
        provinceCode:that.pcode,
        cityCode:that.ccode,
        companyId:that.companyId
      }
      Indicator.open()
      perfect(params).then(res => {
        Indicator.close();
        if (res.data.returnCode === 1) {
            this.$router.push({ path: '/vGroup', query: { year: that.yearTerm  } })
        } else {
          Toast(res.data.returnMsg)
        }
      })
    },
    onConfirm(picker, value, index){
      console.log(picker);
      var that = this;
      that.needwsBox = false;
      if(that.curSelType===0){
        that.pcode = picker.id;
        that.ptext = picker.text;
        that.ccode = '';
        that.ctext = '';
      }
      if(that.curSelType===1){
        that.ccode = picker.id;
        that.ctext = picker.text;
        that.companyId = '';
        that.companyText = '';
      }
      if(that.curSelType===2){
        console.log(picker);
        that.companyId = picker.id;
        that.companyText = picker.text;
      }
    },
    onCancel(){
      this.needwsBox = false;
      console.log('点击了取消按钮');
    },
    getProvince:function(){
      var that = this;
      Indicator.open()
      getProvince().then(res => {
        Indicator.close()
        if (res.data.returnCode === 1) {
          var carr = res.data.returnDate;
            carr.forEach(element => {
              var co = {
                id:element.code,
                text:element.name
              }
              that.dataList.push(co);
            });
        } else {
          Toast(res.data.returnMsg)
        }
      })
    },
    getCity:function(params){
      var that = this;
      Indicator.open()
      getCity(params).then(res => {
        Indicator.close()
        if (res.data.returnCode === 1) {
          var carr = res.data.returnDate;
            carr.forEach(element => {
              var co = {
                id:element.code,
                text:element.name
              }
              that.dataList.push(co);
            });
        } else {
          Toast(res.data.returnMsg)
        }
      })
    },
    getCompany:function(params){
      var that = this;
      Indicator.open()
      getCompany(params).then(res => {
        Indicator.close()
        if (res.data.returnCode === 1) {
          var carr = res.data.returnDate;
            carr.forEach(element => {
              var co = {
                id:element.id,
                text:element.name
              }
              that.dataList.push(co);
            });
        } else {
          Toast(res.data.returnMsg)
        }
      })
    },
    getTrainlists () {
      Indicator.open()
      var _this = this
      var curDate = new Date()
      var userId = sessionStorage.getItem('userId')
      getTrainlistAqxx({
        userId: userId,
        year: curDate.getFullYear()
      }).then(res => {
        if (res.data.returnCode === 1) {
          Indicator.close()
          _this.classlist = res.data.returnDate.data
          this.isHasdata = true
          if (res.data.returnDate.data.length < 1) {
            this.isHasdata = false
          }
        } else {
          this.isHasdata = false
          Indicator.close()
          Toast(res.data.returnMsg)
        }
      })
    },
    toCourseList (year) {
      Toast('缴费成功请在app上面进行学习')
      // var that = this;
      // if (
      //   sessionStorage.getItem('photo') === '' ||
      //   sessionStorage.getItem('photo') === null ||
      //   sessionStorage.getItem('photo') === undefined
      // ) {
      //   Toast('未上传头像，无法学习！')
      // } else {
      //     //this.$router.push({ path: '/vGroup', query: { year: year,hyCode:hyCode } })
      //   Indicator.open()
      //   //判断是否需要完善信息
      //   needws().then(res => {
      //     Indicator.close()
      //     if (res.data.returnCode === 1) {
      //         var isBox  = res.data.returnDate;
      //         if(!isBox){
      //           this.$router.push({ path: '/vGroup', query: { year: year} })
      //         }else{
      //           //弹出完善信息界面
      //           that.showBox = res.data.returnDate;
      //           // that.hyTerm = hyCode;
      //           that.yearTerm = year;
      //         }
      //     } else {
      //       Toast(res.data.returnMsg)
      //     }
      //   })
      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SafeLearning.vue